import React, {  useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { IconTextField } from '../../Components/shared/ReusableSmallComponents';
import { getPaymentSimulationResults } from '../../Utils/utilsCraX';

const CalculationSimulator = () => {
    const [futureMission, setFutureMission] = useState({
        tj: '',
        tjClient: '',
        commissionHTH: ''
    });
    // const [tj, setTj] = useState(0);
    // const [tjClient, setTjClient] = useState(0);
    // const [commissionHTH, setCommissionHTH] = useState(0);
    const [LastModifiedArg, setLastModifiedArg] = useState('');
    const [beforeLastModifiedArg, setBeforeLastModifiedArg] = useState('');
    const [borderColor, setBorderColor] = React.useState('Mui-error');
    const { i18n } = useTranslation();

    useEffect(() => {
        if (futureMission.commissionHTH < 12) {
            setBorderColor('red');
        } else if (futureMission.commissionHTH >= 12 && futureMission.commissionHTH < 15) {
            setBorderColor('orange');
        } else if (futureMission.commissionHTH >= 15 && futureMission.commissionHTH < 20) {
            setBorderColor('blue');
        } else if (futureMission.commissionHTH >= 20) {
            setBorderColor('green');
        }
        /*
        const useStyles = makeStyles((theme) => ({
    root: {
        '& .MuiOutlinedInput-root': {
            '&.Mui-error': {
                borderColor: theme.palette.error.main,
            },
            '&.Mui-warning': {
                borderColor: theme.palette.warning.main,
            },
            '&.Mui-success': {
                borderColor: theme.palette.success.main,
            },
            '&.Mui-primary': {
                borderColor: theme.palette.primary.main,
            },
        },
    },
}));

    const classes = useStyles();
setBorderColor('Mui-error');
        */
    }, [futureMission]);

    const handleChange = (prop) => async (event) => {
        let  value = event.target.value;
        console.log('11111LastModifiedArg',LastModifiedArg, 'beforeLastModifiedArg', beforeLastModifiedArg , {[prop]: value}, futureMission);
        // if(LastModifiedArg != beforeLastModifiedArg)
        //     setBeforeLastModifiedArg(LastModifiedArg);
        // if(prop !== LastModifiedArg)
        //     setLastModifiedArg(prop);

        // if(prop == 'tj'){
        //     setTj(value);
        // }
        // else if(prop == 'tjClient'){
        //     setTjClient(value);
        // }
        // else if(prop == 'commissionHTH'){
        //     setCommissionHTH(value);
        // }
        // * the first case of Last modifiedArg, before having a new modifiedArg
        if(prop==LastModifiedArg){
            setFutureMission({
            // ...futureMission,
                [beforeLastModifiedArg]: futureMission[beforeLastModifiedArg],
                [prop]: Number(value),
                ...getPaymentSimulationResults({
                    [beforeLastModifiedArg]: futureMission[beforeLastModifiedArg],
                    [prop]: value}),
            });
        }
        if(LastModifiedArg=='')
            setLastModifiedArg(prop);
        else if(prop!==LastModifiedArg){
            setFutureMission({
                // ...futureMission,
                [LastModifiedArg]: futureMission[LastModifiedArg],
                [prop]: value,
                ...getPaymentSimulationResults({
                    [LastModifiedArg]: futureMission[LastModifiedArg],
                    [prop]: value}),
            });
            setBeforeLastModifiedArg(LastModifiedArg);
            setLastModifiedArg(prop);
        }
        console.log('222222LastModifiedArg',LastModifiedArg, 'beforeLastModifiedArg', beforeLastModifiedArg , {[prop]: value}, futureMission);

    };
    // * some logical though to get the work done
    // * we must keep track of data conformity
    // useEffect(() => {
    //     if (a && b && a !== b * c) {
    //         setC(a / b);
    //     } else if (a && c && a !== b * c) {
    //         setB(a / c);
    //     } else if (b && c && a !== b * c) {
    //         setA(b * c);
    //     }
    // }, [a, b, c]);
    // * and Also the last and why not the before last input changed
    // const [lastModified, setLastModified] = useState(null);

    // useEffect(() => {
    //   if (lastModified === 'a') {
    //     setC(a / b);
    //   } else if (lastModified === 'b') {
    //     setA(b * c);
    //   } else if (lastModified === 'c') {
    //     setB(a / c);
    //   }
    // }, [a, b, c, lastModified]);

    // const handleAChange = (e) => {
    //   setA(Number(e.target.value));
    //   setLastModified('a');
    // };

    return (
        <>
            <div className='frame5Profile'>{i18n.t('High Tech Hires')} &gt; <span style={{color:'rgba(39, 45, 60, 1)'}}> {i18n.t('Simulateur')}</span> </div>
            <h4 className='titlesociete'>
                {i18n.t('Simulateur')}
            </h4>
            <div className='row3' >
                <div className='insiderow1'>
                    <label className='labelsociete'>{i18n.t('Taux journalier/expert')}</label>
                    <IconTextField
                        //className='clo-6'
                        id="outlined-start-adornment"
                        //iconStart={'Taux'}
                        iconEnd={'€'}
                        //InputProps={{
                        //    startAdornment: (<div className='iconStyleStartAdornment'>
                        //        <InputAdornment position="start">Taux</InputAdornment>
                        //    </div>
                        //    ),
                        //    endAdornment: (<div className='iconStyleStartAdornment iconStyleEndAdornment'>
                        //        <InputAdornment position="end">€</InputAdornment>
                        //    </div>
                        //    ),
                        //}}
                        style={{ width: '100%',background:'white'}}
                        sx={{
                            '& > :not(style)': { borderRadius: '8px' },
                        }}
                        type="number"
                        name="tj"
                        // * OLD TJ Method value={getTjExpert(futureMission.tj)}
                        // value={tj}
                        // onChange={handleChange('tj')}
                        value={futureMission.tj|| ''}
                        //value={futureMission.tj}
                        onChange={handleChange('tj')}
                        autoComplete="off"
                    />
                </div>
                <div className='insiderow1'>
                    <label className='labelsociete'>{i18n.t('Taux journalier/client')}</label>
                    <IconTextField
                        //className='clo-6'
                        id="outlined-start-adornment"
                        //sx={{ width: 538.5 }}
                        style={{ width: '100%',background:'white'}}
                        sx={{
                            '& > :not(style)': { borderRadius: '8px' },
                        }}
                        //iconStart={'Taux'}
                        iconEnd={'€'}
                        //InputProps={{
                        //    startAdornment: (<div className='iconStyleStartAdornment'><InputAdornment position="start">Taux</InputAdornment> </div>),
                        //    endAdornment: (<div className='iconStyleStartAdornment iconStyleEndAdornment'><InputAdornment position="end">€</InputAdornment></div>),

                        //}}
                        type="number"
                        name="tjClient"
                        value={futureMission.tjClient || ''}
                        //value={futureMission.tjClient}
                        //value={futureMission.tjClient}
                        onChange={handleChange('tjClient')}
                        autoComplete="off"
                    />
                </div>
            </div>
            <div className='row3' >
                <div className='insiderow1'>
                    <label
                        className='labelsociete'
                        style={{color: borderColor}}
                    >{i18n.t('Taux de commission')}</label>
                    <IconTextField
                        //className='clo-6'
                        id="outlined-start-adornment"
                        sx={{
                            '& .MuiInputBase-input': {
                                color: borderColor, // Change to your desired color
                            },
                            '& > :not(style)': { borderRadius: '8px' },
                        }}
                        style={{ width: '100%',background:'white',borderRadius: '8px',color: borderColor}}
                        //sx={{ width: 538.5 }}
                        iconStart={'%'}
                        //InputProps={{
                        //    startAdornment: (
                        //        <div className='iconStyleStartAdornment'>
                        //            <InputAdornment position="start">
                        //                        %
                        //            </InputAdornment>
                        //        </div>),
                        //}}
                        type="number"
                        name="commission"
                        value={futureMission.commissionHTH||''}
                        onChange={handleChange('commissionHTH')}
                        // * OLD commissionHTH
                        autoComplete="off"
                        // color='error'
                    />
                </div>
                {/* <div className='insiderow2'>
                    <div
                        style={{ borderColor,  width: 538.5, height: 56 }}
                    />
                </div> */}
            </div>
        </>
    );
};

export default CalculationSimulator;

// export const getTjClient= (tj, commissionHTH=20) => {
//     // * methode 2 :
//     if (commissionHTH >= 0 && commissionHTH <= 1) {
//         return Math.round(Number(tj) / Number(1 - commissionHTH));
//     } else if (commissionHTH >= 2 && commissionHTH <= 100) {
//         return Math.round(Number(tj) / Number(1 - (commissionHTH/100)));
//     }
//     // * methode 1 : OLD
//     // if (commissionHTH >= 0 && commissionHTH <= 1) {
//     //     return Math.round(Number(tj) - Number(tj * (commissionHTH)));
//     // } else if (commissionHTH >= 2 && commissionHTH <= 100) {
//     //     return Math.round(Number(tj) - Number(tj * (commissionHTH/100)));
//     // }
// };

// export const getTjExpert= (tj) => {
//     return  Math.round(tj);
// };